export default __webpack_public_path__ + "static/media/MSNBC.389f7331.svg";